import { Box, CircularProgress, FormControl, Grid, MenuItem, Select, Typography } from "@mui/material";
import { MainContainer } from "../../components/MainContainerComp";
import { getKeyByValue } from "../../utils";
import { config } from "../../utils/config";
import getUser from "../../utils/getUser";
import { HallChalkBoardView } from "./HallChalkBoardsModel";
import { asteriskStyle, selectMenuStyle, selectStyle } from "./styled";

export interface IHallChalkBoardsProps {
  view: HallChalkBoardView,
  onViewSelect: (view: HallChalkBoardView) => void;
  onLoad: () => void;
  loading: boolean,
}

export const HallChalkBoards: React.FC<IHallChalkBoardsProps> = ({
  view,
  onViewSelect,
  onLoad,
  loading
}) => {
  const user = getUser();
  return (
    <MainContainer hasGreyBg>
      <Grid container>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormControl sx={{ mt: 2, mb: 2 }} fullWidth>
            <Typography sx={{ mb: 1 }}>Select a View <Typography component={"span"} sx={asteriskStyle}>&nbsp;*</Typography></Typography>
            <Select
              disabled={loading}
              sx={selectStyle}
              displayEmpty
              value={view}
              onChange={e => onViewSelect(e.target.value as HallChalkBoardView)}
              MenuProps={{ sx: selectMenuStyle }}
            >
              {Object.entries(HallChalkBoardView).map(([key, value]) => (
                <MenuItem key={key} value={getKeyByValue(HallChalkBoardView, value)}>
                  {value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Box sx={{ position: 'relative' }}>
        {loading && <CircularProgress style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />}
        {view && <iframe
          id="hall-chalk-boards"
          title="HTML Content"
          src={`${config.apiUrl}/legacy-cb-${view}?j=${user?.access_token}`}
          style={{ width: '100%', height: 'calc(100vh - 215px)' }}
          onLoad={onLoad}
        />}
      </Box>
    </MainContainer>
  )
}